import Reac, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import Link from "next/link";
import Image from "next/legacy/image";
import * as Text from "@/components/text";
import useWindowSize from "@/hooks/useWindowSize";
import Metadata from "../film/Metadata";
import Award from "../film/Award";
import Button from "../actions/Button";
import { useRouter } from "next/router";
import { localeTexts} from "@/utils/locale";
import { getStrapiImage } from "@/utils/strapiFunctions";

export default function FeaturedTitle({
  trailer_link = "",
  active,
  film_name,
  original_title,
  film_cover,
  initiatives,
  setColor,
  directors,
  film_year,
  countries,
  film_length,
  slug,
  awards,
  film_metadata = {
    duration: "100",
    year: "2020",
    countries: ["Mexico, Argentina"],
  },
}) {
    const windowSize = useWindowSize();
    const router = useRouter();
    const [locale, setLocale] = useState("es-MX");
    const t = localeTexts[locale]?.common || {};
    const excludedPrefixes = {
  'es-MX': ['mex', 'línea'],
  'en-US': ['mex', 'line']
  };

  // Sync locale with URL and localStorage

  useEffect(() => {
  if (!router.isReady) return;
  const urlLocale = router.query.locale;
  const storedLocale = typeof window !== "undefined"
  ? localStorage.getItem("amb-locale")
  : null;

  const finalLocale = urlLocale || storedLocale || "es-MX";
  setLocale(finalLocale);
  localStorage.setItem("amb-locale", finalLocale);
  }, [router.isReady, router.query.locale]);

    useEffect(() => {
      if (active) {
        setColor(initiatives?.data[0]?.id || 0);
      }
    }, [active, initiatives]);

  const getCountries = (countries) => {
    const res = countries.map((c) => c.countries);
    return res;
  };

  return (
    <>
      <div className="sm:h-[460px] sm:w-[100%] lg:h-[500px] xl:max-w-[1207px]">
        <div className="amb-container absolute h-full">
          <div className="relative top-0 z-0 aspect-[4/7] lg:aspect-video">
            <img
              className="h-full w-full object-cover object-center "
              src={
                getStrapiImage(film_cover, "large") ||
                "https://images.unsplash.com/photo-1658686873732-c93680078088?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1287&q=80"
              }
              alt="Film picture"
            />
            <div className="absolute  bottom-0 left-0 block h-full w-full bg-gradient-to-t from-neutral-900/90 to-neutral-50/10"></div>
          </div>

          <div className="absolute bottom-10 z-10 ml-10  space-y-1">
            <Text.Headline
              className="text-white"
              as="h2"
              size={windowSize.width < 720 ? "sm" : "xl"}
            >
              {film_name}
            </Text.Headline>
            <Text.Headline as="h3" className="text-white" size="md">
              {original_title}
            </Text.Headline>
            <Text.Body
              as="div"
              className={"font-bold` text-white last:after:content-[''] "}
              size="md"
            >
              {directors.map(({ Director, id }, i) => (
                <span className=" pr-2" key={id}>
                  {Director} {i === directors.length - 1 ? null : ","}
                </span>
              ))}
            </Text.Body>
            {/* Meta */}
            <div className="meta-same-h">
              <Metadata
                film_metadata={{
                  duration: film_length,
                  year: film_year ? film_year[0].year : "",
                  countries:
                    countries.length > 0
                      ? [countries.map((c) => c.countries).join(", ")]
                      : "",
                }}
                className={"text-neutral-100"}
                theme="dark"
                size="md"
              />
            </div>
            <div>
              <Link href={`/catalogo/${slug}`}>
                <Button color="terciary-dark" label={t.viewDetails} />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
